import React, { useEffect, useState, memo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Popover } from 'antd'
import LazyLoad from 'react-lazyload'
import { UseGalleryModal } from '../gallery-modal'
import defaultImg from '~/img/buy/loading.png'
import './index.scss'

const Gallery = (props) => {
  const { another, basic } = props
  const { phone } = useSelector(store => store.user)
  const city = useSelector(store => store.city)
  const { fr, ino } = city
  const basicInfo = basic.basic_info
  const { sellersaid, owner } = another
  const { images } = basic
  const [carTxtInfo, setCarTxtInfo] = useState({})
  const [picMap, setPicMap] = useState({})
  const getImgUrl = (img) => {
    if (img.span) {
      return `${img.img_url}?imageView/4/w/1400/h/960/interlace/1/format/jpg|imageMogr2/strip${img.scale ? `/thumbnail/!${img.scale}p` : ''}/${img.rotate ? `rotate/${img.rotate}/` : ''}crop/!${290 * (img.span || 0) / 3 + 10 * ((img.span || 0) / 3 - 1)}x${img.height ? img.height : ''}${img.offsetX ? `a${img.offsetX.replace(/^-/, '')}` : 'a0'}${img.offsetY ? `a${img.offsetY.replace(/^-/, '')}` : 'a0'}`
    }
    return `${img.img_url}?imageView/4/w/586/h/392/interlace/1/format/jpg`
  }
  const imgsPart = {
    车身外观: [],
    中控内饰: [],
    发动机底盘: []
  }
  images.filter(e => e && e.img_url).map((item) => {
    if (!imgsPart[item.part]) {
      imgsPart[item.part] = []
    }
    imgsPart[item.part].push(item)
    return null
  })
  useEffect(() => { setCarTxtInfo(another.procedures_information) }, [another.procedures_information])
  useEffect(() => {
    if (another.annotation_images?.length > 0) {
      const annotationImages = another.annotation_images
      // // 车身外观小图片  取images数组中'车身外观'这类图片的左后尾灯或右后尾灯(因为这两个不会做为标注图，避免跟上面取的图片重复) 都没有就取车身外观最后一张*
      let indexLastFlag = false
      let indexLastFlagDipan = false
      // 外观四张大图、三张小图
      const waiguanBig = [
        annotationImages[0],
        annotationImages[1]
      ]
      if (annotationImages[2]?.children) {
        annotationImages[2]?.children[0] && waiguanBig.push(annotationImages[2]?.children[0])
        annotationImages[2]?.children[1] && waiguanBig.push(annotationImages[2]?.children[1])
      }
      const waiguanSmall = []
      if (annotationImages[3]?.children) {
        annotationImages[3]?.children[0] && waiguanSmall.push(annotationImages[3]?.children[0])
        annotationImages[3]?.children[1] && waiguanSmall.push(annotationImages[3]?.children[1])
      }
      // 内饰六张大图、三张小图
      const neishiBig = []
      const neishiBigIndexs = [4, 5, 6]
      neishiBigIndexs.map((i) => {
        if (annotationImages[i]?.children) {
          annotationImages[i]?.children[0] && neishiBig.push(annotationImages[i]?.children[0])
          annotationImages[i]?.children[1] && neishiBig.push(annotationImages[i]?.children[1])
        }
        return true
      })

      const neishiSmall = []
      if (annotationImages[8]?.children) {
        annotationImages[8]?.children[0] && neishiSmall.push(annotationImages[8]?.children[0])
        annotationImages[8]?.children[1] && neishiSmall.push(annotationImages[8]?.children[1])
        annotationImages[8]?.children[2] && neishiSmall.push(annotationImages[8]?.children[2])
      }
      // 发动机底盘两张大图
      const dipanBig = [
        annotationImages[9]
      ]
      images.filter(e => e && e.img_url).map((item, index) => {
        // 车身外观小图填充 填充的数据要添加 data_start ,点击查看大图定位位置
        if (!indexLastFlag) {
          if (item?.anno === '左后尾灯' || item?.anno === '右后尾灯') {
            indexLastFlag = true
            waiguanSmall.push({ ...item, data_start: index })
            return null
          }
          if (item.part === '车身外观') {
            indexLastFlag = true
            waiguanSmall.push({ ...item, data_start: index })
          }
        }
        // 发动机底盘大图填充
        if (!indexLastFlagDipan) {
          if (item?.anno === '发动机右侧' || item?.anno === '发动机左侧') {
            indexLastFlagDipan = true
            dipanBig.push({ ...item, data_start: index })
            return null
          }
          if (item.part === '发动机底盘') {
            indexLastFlagDipan = true
            dipanBig.push({ ...item, data_start: index })
          }
        }
        return null
      })
      setPicMap({
        waiguanBig,
        waiguanSmall,
        neishiBig,
        neishiSmall,
        dipanBig
      })
    }
  }, [another.annotation_images])

  const replaceDate = date => (date ? date.replace(/-01$/g, '') : '-')
  // 过户次数tip
  const transferTip = (
    <div className="r-outer-tip">
      该信息应以车辆登记证书登记为准。
    </div>
  )

  const onPicClick = (currentPicNum) => {
    const submitParams = {
      phone: phone || '',
      mobile_number: phone || '',
      phone_source: `${fr}${ino ? '_异地' : ''}`
    }
    const otherParams = {
      ino, basicInfo, tags: basic.tags, images: basic.images, phoneSource: city.phone_source
    }
    new UseGalleryModal({ submitParams, otherParams, currentPicNum }).open()
  }


  return (
    <>
      <div className="r-gallery" data-exposure="car-detail_cardetailinfor_display">
        <h2>车辆详情</h2>
        <div className="clearfix">
          <div className="seller">
            <div className="owner clearfix">
              <div className="owner-img">
                <LazyLoad><img src={owner?.avatar} alt="卖家" /></LazyLoad>
              </div>
              <div className="owner-desc">
                <p className="name">{owner?.name}</p>
              </div>
            </div>
            <p className="desc">{sellersaid?.content}</p>
          </div>
          <div className="car-info">
            <p>车辆手续信息</p>
            <table>
              <tbody>
                <tr>
                  <td>年检到期时间</td>
                  <td>{replaceDate(carTxtInfo?.transport_test_expire)}</td>
                  <td>交强险到期时间</td>
                  <td>{replaceDate(carTxtInfo?.compulsory_insurance_expire)}</td>
                </tr>
                <tr>
                  <td>商业险到期时间</td>
                  <td>{replaceDate(carTxtInfo?.commercial_insurance_expire)}</td>
                  <td>过户次数</td>
                  <td>{carTxtInfo?.transfer_records?.length}次
                    <Popover content={transferTip} title={null} placement="top">
                      <i className="iconfont icon-tip-icon2-07d8d303" />
                    </Popover>
                  </td>
                </tr>
                <tr>
                  <td>有无购车发票</td>
                  <td>{carTxtInfo?.has_invoice}</td>
                  <td>车辆购置税完税证明</td>
                  <td>{carTxtInfo?.has_purchase_tax_credential || '-'}</td>
                </tr>
                <tr>
                  <td>是否4S店保养</td>
                  <td>{carTxtInfo?.has_4s_maintainance}</td>
                  <td>有无改装</td>
                  <td>{carTxtInfo?.is_refitted || '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* 车辆外观 */}

          <div className="car-appearance clearfix">
            <h2>
              车辆外观
              <span>
                车况优秀，性能部件正常使用，经检测，外观及车身结构无重大撞击。
              </span>
            </h2>

            <div className="clearfix">
              {picMap.waiguanBig
                && picMap.waiguanBig.length > 0
                && picMap.waiguanBig.filter(e => e && e.img_url).map((item, index) => (
                  <div
                    key={index}
                    className={`img-box big ${index > 1 ? 'mt-20' : ''} ${
                      index % 2 === 0 ? '' : 'ml-20'
                    }`}
                    data-exposure={JSON.stringify({
                      event: 'car-detail_descriptionimages_display',
                      content: { expand: { tag_value: item?.title || item?.anno } }
                    })}
                  >
                    <LazyLoad><img src={getImgUrl(item) || defaultImg} alt={item?.title || ''} onClick={() => { onPicClick(item?.data_start) }} /></LazyLoad>
                    <p>
                      <span className="title">{item?.title}:</span>
                      <span>{item?.desc}</span>
                    </p>
                  </div>
                ))}
            </div>
            <div className="clearfix">
              {picMap.waiguanSmall
                  && picMap.waiguanSmall.length > 0
                  && picMap.waiguanSmall.filter(e => e && e.img_url).map((item, index) => (
                    <div
                      key={index}
                      className={`img-box small mt-20 ${index > 0 ? 'ml-20' : ''}`}
                      onClick={() => { onPicClick(item?.data_start) }}
                      data-exposure={JSON.stringify({
                        event: 'car-detail_descriptionimages_display',
                        content: { expand: { tag_value: item?.title || item?.anno } }
                      })}
                    >
                      <LazyLoad><img src={getImgUrl(item) || defaultImg} alt={item?.title || ''} /></LazyLoad>
                    </div>
                  ))}
              <div className="img-box small ml-20 mt-20" onClick={() => { onPicClick(0) }}>
                <LazyLoad><img className="blur" src={getImgUrl(images[0]) || defaultImg} alt={images[0].title} /></LazyLoad>
                <p className="more">查看更多外观细节</p>
              </div>
            </div>

            {/* 车辆内饰 */}

            <h2 className="mt-60">
              车辆内饰
              <span>
                车内部件功能正常使用，内饰、座椅磨损程度正常，座椅底部、安全带根部等无水泡痕迹。
              </span>
            </h2>
            <div className="clearfix">
              {picMap.neishiBig
              && picMap.neishiBig.length > 0
              && picMap.neishiBig.filter(e => e && e.img_url).map((item, index) => (
                <div
                  key={index}
                  className={`img-box big ${index > 1 ? 'mt-20' : ''} ${index % 2 === 0 ? '' : 'ml-20'}`}
                  data-exposure={JSON.stringify({
                    event: 'car-detail_descriptionimages_display',
                    content: { expand: { tag_value: item?.title || item?.anno } }
                  })}
                >
                  <LazyLoad><img src={getImgUrl(item) || defaultImg} alt="车源详情图" onClick={() => { onPicClick(item?.data_start) }} /></LazyLoad>
                  <p>
                    <span className="title">{item?.title}:</span>
                    <span>{item?.desc}</span>
                  </p>
                </div>
              ))}
            </div>
            <div className="clearfix">
              {picMap.neishiSmall
                && picMap.neishiSmall.length > 0
                && picMap.neishiSmall.filter(e => e && e.img_url).map((item, index) => (
                  <div
                    key={index}
                    className={`img-box small mt-20 ${index > 0 ? 'ml-20' : ''}`}
                    onClick={() => { onPicClick(item?.data_start) }}
                    data-exposure={JSON.stringify({
                      event: 'car-detail_descriptionimages_display',
                      content: { expand: { tag_value: item?.title || item?.anno } }
                    })}
                  >
                    <LazyLoad><img src={getImgUrl(item) || defaultImg} alt={item?.title || ''} /></LazyLoad>
                  </div>
                ))}
              <div className="img-box small ml-20 mt-20" onClick={() => { onPicClick(0) }}>
                <LazyLoad><img className="blur" src={getImgUrl(images[0]) || defaultImg} alt={images[0].title} /></LazyLoad>
                <p className="more">查看更多内饰细节</p>
              </div>
            </div>

            {/* 发动机底盘 */}

            <h2 className="mt-60">  发动机底盘<span>油液位及品质正常，油封不泄露，线路管无剥落</span> </h2>
            <div className="clearfix">
              {picMap.dipanBig
              && picMap.dipanBig.length > 0
              && picMap.dipanBig.filter(e => e && e.img_url).map((item, index) => (
                <div
                  key={index}
                  className={`img-box big ${index > 1 ? 'mt-20' : ''} ${index % 2 === 0 ? '' : 'ml-20'}`}
                  onClick={() => { onPicClick(item?.data_start) }}
                  data-exposure={JSON.stringify({
                    event: 'car-detail_descriptionimages_display',
                    content: { expand: { tag_value: item?.title || item?.anno } }
                  })}
                >
                  <LazyLoad><img src={getImgUrl(item) || defaultImg} alt={item?.title || item?.anno} /></LazyLoad>
                </div>
              ))}
            </div>


            {/* '车身外观', '中控内饰', '发动机底盘' */}

            <ul className="clearfix">
              {['车身外观', '中控内饰', '发动机底盘'].map((part, index0) => (
                <li key={part}>
                  <p>
                    <i className="iconfont icon-detailCarInfo-87e96ec7" />
                    {part}({imgsPart[part].length}张)
                  </p>
                  <div className="clearfix">
                    {imgsPart[part].slice(0, 4).map((item, index) => (
                      <div
                        key={index}
                        className={`img-box xsmall ${
                          index > 1 ? 'mt-10' : 'mt-20'
                        } ${index % 2 === 0 ? '' : 'ml-10'}`}
                        onClick={() => { onPicClick(index0 === 0 ? index : index0 === 1 ? imgsPart['车身外观'].length + index : imgsPart['车身外观'].length + imgsPart['中控内饰'].length + index) }}
                        data-exposure={JSON.stringify({
                          event: 'car-detail_descriptionimages_display',
                          content: { expand: { tag_value: item?.title || item?.anno } }
                        })}
                      >
                        <LazyLoad><img src={`${item?.img_url}?imageView2/1/interlace/1/q/75/w/160/h/126/format/jpg` || defaultImg} alt={item?.title || item?.anno} /></LazyLoad>
                      </div>
                    ))}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(Gallery)
Gallery.propTypes = {
  another: PropTypes.object,
  basic: PropTypes.object
}

Gallery.defaultProps = {
  another: {},
  basic: {}
}
